export default __webpack_public_path__ + "static/media/Rectangle 102.6b8cc542.png";